import useHttpMutation from 'data/firestore/useHttpMutation';

export default (
    agentId: string,
    pathname?: string,
) => useHttpMutation<Record<string, any>, unknown>({
    method: 'POST',
    pathname: pathname || `/agents/${agentId}/template-partials/import`,
});
